/**
 * tshirtDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const tshirtDesignsPack: ToilePack = {
    slug: 'tshirt-designs',
    category: 'tshirt',
    name: 'T-shirt designs',
    tagline: tagline('graphics', 'designs', 'print styles'),
    chips: chips('designs', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'mountain', label: 'Wild Ridge', subject: 'a mountain adventure badge, layered peaks, pine forest and a rising sun'},
        {key: 'skull', label: 'Skull & florals', subject: 'a skull wreathed in poppies and daisies, vines through the sockets'},
        {key: 'wave', label: 'Afterglow', subject: 'a retro sunset over a breaking wave, striped sun bands and a palm'},
    ],
    styles: [
        {key: 'distressed', label: 'Vintage distressed', style: 'vintage distressed, worn faded ink', palette: 'muted three-color, cracked texture', framing: 'flat print-ready sheet, no mockup'},
        {key: 'line', label: 'Minimal line', style: 'minimal line art, one even stroke weight', palette: 'single ink, no fills', framing: 'flat print-ready sheet, no mockup'},
        {key: 'cartoon', label: 'Bold cartoon', style: 'bold cartoon, exaggerated shapes', palette: 'thick black outlines, flat vivid color', framing: 'flat print-ready sheet, no mockup'},
    ],
    directions: ['a surf theme instead', 'in one ink on black', 'a small left-chest version'],
}
